import script from "./MealListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MealListItem.vue?vue&type=script&setup=true&lang=js"

import "./MealListItem.vue?vue&type=style&index=0&id=3933b275&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3933b275"]])

export default __exports__